import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { EtiquetadoContextService } from "../../context/etiquetado-context.service";
import { EtiquetadoService } from "../../services/etiquetado.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Router } from "@angular/router";
import { Message, SpinnerService, UtilsService } from "shared-components";

@Component({
  selector: "app-totales",
  templateUrl: "./totales.component.html",
})
export class TotalesComponent implements OnInit, OnDestroy {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
  private _filters;
  public filtersVisible = true;
  public filtersForm: UntypedFormGroup;

  public toCloseSpinner = 0;

  public totales;
  public denominaciones = [];
  public campanyas = [];
  public marcas = [];
  public etiquetadores = [];

  public lsPaises;

  public orderBy: string;
  public indexOrder = 5;
  public indexOrderFecha = 5;

  public destino = false;
  public fechasImpresion = false;

  public mensajes = new Array<Message>();
  public showError: boolean;
  public showWarning: boolean;

  public disabledDenominaciones: Subject<boolean> = new Subject();
  public disabledCampanyas: Subject<boolean> = new Subject();
  public disabledMarcas: Subject<boolean> = new Subject();
  public disabledEtiquetadores: Subject<boolean> = new Subject();

  public initialStatePaises = "noSelected";
  public initialStateDenominaciones = "noSelected";
  public initialStateCampanyas = "noSelected";
  public initialStateEtiquetadores = "noSelected";

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public totalItems: number;
  public readonly visiblePages = 3;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly _router: Router,
    private _fb: UntypedFormBuilder,
    private readonly _translate: TranslateService,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService,
    private readonly _etiquetadoService: EtiquetadoService,
    private readonly _etiquetadoContext: EtiquetadoContextService,
    private readonly _dataProvider: DataProvider,
    private readonly _utilsService: UtilsService
  ) {}

  ngOnInit() {
    this.filtersForm = this._fb.group({
      pais: ["", Validators.required],
      denominacion: [{ value: "", disabled: true }],
      campanya: [{ value: "", disabled: true }],
      etiquetador: [{ value: "", disabled: true }],
      marca: [{ value: "", disabled: true }],
      paisDestino: [""],
      fechaInicio: ["", Validators.required],
      fechaFin: ["", Validators.required],
      desglosePaisDestino: [false],
      fechasImpresion: [false],
      agruparEtiquetador: [false],
    });

    this._etiquetadoContext.totalesFilters = null;

    this.checkWarnings(this.filtersForm.get("pais").value);

    this.filtersForm.get("pais").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((lsPaises) => {
      if (lsPaises) {
        this.lsPaises = lsPaises;
        this.getDenominacionesByPais(lsPaises);
      } else {
        this.initialStateDenominaciones = "noSelected";
        this.disabledDenominaciones.next(true);
        this.denominaciones = [];
        this.filtersForm.get("denominacion").patchValue("");
        this.filtersForm.get("denominacion").disable();
      }
    });

    if (this._dataProvider.paises) {
      if (
        this._dataProvider.paises.length === 1 &&
        this.filtersForm.get("pais").enabled
      ) {
        this.initialStatePaises = "allSelected";
        this.filtersForm.get("pais").disable();
      }
    }

    this.filtersForm
      .get("denominacion")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((lsDenominaciones) => {
        if (lsDenominaciones) {
          this.getCampanyasByDenominacion(lsDenominaciones, this.lsPaises);
          this.getMarcasByDenominacion(lsDenominaciones, this.lsPaises);
          this.getEtiquetadoresByDenominacion(lsDenominaciones, this.lsPaises);
        } else {
          this.initialStateCampanyas = "noSelected";
          this.disabledCampanyas.next(true);
          this.campanyas = [];
          this.filtersForm.get("campanya").patchValue("");
          this.filtersForm.get("campanya").disable();
          this.disabledMarcas.next(true);
          this.marcas = [];
          this.filtersForm.get("marca").patchValue("");
          this.filtersForm.get("marca").disable();
          this.initialStateEtiquetadores = "noSelected";
          this.disabledEtiquetadores.next(true);
          this.etiquetadores = [];
          this.filtersForm.get("etiquetador").patchValue("");
          this.filtersForm.get("etiquetador").disable();
        }
      });

    this.filtersForm.get("campanya").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((lsCampanyas) => {
      if (lsCampanyas && lsCampanyas.length > 0) {
        this.filtersForm.get("fechaInicio").clearValidators();
        this.filtersForm
          .get("fechaInicio")
          .updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this.filtersForm.get("fechaFin").clearValidators();
        this.filtersForm
          .get("fechaFin")
          .updateValueAndValidity({ onlySelf: true, emitEvent: false });
      } else {
        this.filtersForm.get("fechaInicio").setValidators(Validators.required);
        this.filtersForm
          .get("fechaInicio")
          .updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this.filtersForm.get("fechaFin").setValidators(Validators.required);
        this.filtersForm
          .get("fechaFin")
          .updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    });

    this.filtersForm.get("fechaInicio").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((des) => {
      this.validDates();
      if (des && this.filtersForm.get("fechaFin").value) {
        if (this.comprobarFechas()) {
          this.showWarning = true;
          this.mensajes.push({
            class: "warning",
            message: "global.fecha.error.masDeUnAnyo",
          });
          this.filtersForm.get("pais").setValidators(Validators.required);
          this.filtersForm
            .get("pais")
            .updateValueAndValidity({ onlySelf: true, emitEvent: false });
        } else {
          this.filtersForm.get("pais").clearValidators();
          this.filtersForm
            .get("pais")
            .updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
      } else {
        this.filtersForm.get("pais").setValidators(Validators.required);
        this.filtersForm
          .get("pais")
          .updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    });

    this.filtersForm.get("fechaFin").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((des) => {
      this.validDates();
      if (des && this.filtersForm.get("fechaInicio").value) {
        if (this.comprobarFechas()) {
          this.showWarning = true;
          this.mensajes.push({
            class: "warning",
            message: "global.fecha.error.masDeUnAnyo",
          });
          this.filtersForm.get("pais").setValidators(Validators.required);
          this.filtersForm
            .get("pais")
            .updateValueAndValidity({ onlySelf: true, emitEvent: false });
        } else {
          this.filtersForm.get("pais").clearValidators();
          this.filtersForm
            .get("pais")
            .updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
      } else {
        this.filtersForm.get("pais").setValidators(Validators.required);
        this.filtersForm
          .get("pais")
          .updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get paises() {
    return this._dataProvider.paises;
  }

  public get destinos() {
    return this._dataProvider.destinos;
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  // Evitar que haya demasiada separación para este último checkbox
  public get addLastCheckboxClass() {
    return window.innerWidth >= 1165;
  }

  public getDenominacionesByPais(lsPaises) {
    this.denominaciones = [];
    let filters = {
      lsPaisIds: lsPaises,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService
      .getDenominaciones(filters)
      .toPromise()
      .finally(() => {
        this.checkCloseSpinner();
      })
      .then((resp) => {
        if (resp.lista.length > 0) {
          this.denominaciones = resp.lista;
          if (this.denominaciones.length === 1) {
            this.initialStateDenominaciones = "allSelected";
            this.filtersForm.get("denominacion").disable();
            this.disabledDenominaciones.next(true);
          } else {
            if (this.filtersForm.get("denominacion").value !== "") {
              return;
            }
            this.initialStateDenominaciones = "noSelected";
            this.filtersForm.get("denominacion").patchValue("");
            this.filtersForm.get("denominacion").enable();
            this.disabledDenominaciones.next(false);
          }
        }
      });
  }

  public getCampanyasByDenominacion(lsDenominaciones, lsPaises) {
    this.campanyas = [];
    let filters = {
      lsDenominacionIds: lsDenominaciones,
      lsPaisIds: lsPaises,
      volcadoHistorico: false,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService
      .getCampanyasMultiSelect(filters)
      .toPromise()
      .finally(() => {
        this.checkCloseSpinner();
      })
      .then((resp) => {
        if (resp.length > 0) {
          resp.forEach((element) => {
            this.campanyas.push({ id: element, des: element.toString() });
          });
          if (this.campanyas.length === 1) {
            this.initialStateCampanyas = "allSelected";
            this.filtersForm.get("campanya").disable();
            this.disabledCampanyas.next(true);
          } else {
            this.initialStateCampanyas = "noSelected";
            this.filtersForm.get("campanya").patchValue("");
            this.filtersForm.get("campanya").enable();
            this.disabledCampanyas.next(false);
          }
        }
      });
  }

  public getMarcasByDenominacion(lsDenominaciones, lsPaises) {
    this.marcas = [];
    let filters = {
      lsDenominacionIds: lsDenominaciones,
      lsPaisIds: lsPaises,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService
      .getMarcas(filters)
      .toPromise()
      .finally(() => {
        this.checkCloseSpinner();
      })
      .then((resp) => {
        if (resp.lista.length > 0) {
          this.marcas = resp.lista;
          this.marcas.push({
            id: -1,
            des: this._translate.instant("global.sinMarca"),
          });
          this.filtersForm.get("marca").enable();
          this.disabledMarcas.next(false);
        }
      });
  }

  public getEtiquetadoresByDenominacion(lsDenominaciones, lsPaises) {
    this.etiquetadores = [];
    let filters = {
      lsDenominacionIds: lsDenominaciones,
      lsPaisIds: lsPaises,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService
      .getEtiquetadores(filters)
      .toPromise()
      .finally(() => {
        this.checkCloseSpinner();
      })
      .then((resp) => {
        if (resp.lista.length > 0) {
          this.etiquetadores = resp.lista;
          if (this.etiquetadores.length === 1) {
            this.initialStateEtiquetadores = "allSelected";
            this.filtersForm.get("etiquetador").disable();
            this.disabledEtiquetadores.next(true);
          } else {
            this.initialStateEtiquetadores = "noSelected";
            this.filtersForm.get("etiquetador").patchValue("");
            this.filtersForm.get("etiquetador").enable();
            this.disabledEtiquetadores.next(false);
          }
        }
      });
  }

  private checkWarnings(pais) {
    if (pais && this.filtersForm.valid) {
      this.filtersVisible = false;
      this.showWarning = false;
      this.mensajes = [];
      this.getTotales();
    } else {
      this.filtersVisible = true;
      this.showWarning = true;

      if (!this.filtersForm.get("pais").value && (!this.filtersForm.get('fechaInicio').value || !this.filtersForm.get('fechaFin').value)) {
        this.mensajes.push({
        class: "warning",
        message: "global.error.requiredTotals",
      });
      } else {
        this.mensajes.push({
          class: "warning",
          message: "global.info.filterRequired",
        });
      }
    }
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = items;
    this.firstItemList = 0;
    this.lastItemList = items;
  }

  public comprobarFechas(): boolean {
    let fechaInicioValor = this.filtersForm.get("fechaInicio").value;
    let fechaFinValor = this.filtersForm.get("fechaFin").value;

    let fechaIni = new Date(fechaInicioValor);
    let fechaFin = new Date(fechaFinValor);

    let diffInYear = this.diffInYears(fechaIni, fechaFin);

    return diffInYear >= 1;
  }

  private diffInYears(date1: Date, date2: Date): number {
    let yearsDiff = date2.getFullYear() - date1.getFullYear();
    let monthDiff = date2.getMonth() - date1.getMonth();
    let dayDiff = date2.getDate() - date1.getDate();

    // Adjust if the current year difference is less than a full year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      yearsDiff--;
    }

    return yearsDiff;
  }

  public validDates() {
    if (
      this.filtersForm.get("fechaInicio").value &&
      this.filtersForm.get("fechaFin").value
    ) {
      if (
        this.checkDates(
          this.filtersForm.get("fechaInicio").value,
          this.filtersForm.get("fechaFin").value
        )
      ) {
        this.clearDatesValidators();
      } else {
        this.filtersForm.get("fechaInicio").setErrors({ invalidDate: true });
        this.filtersForm.get("fechaFin").setErrors({ invalidDate: true });
      }
      if (
        this.filtersForm.get("fechaInicio").invalid ||
        this.filtersForm.get("fechaFin").invalid
      ) {
        this.showError = true;
        this.mensajes.push({
          class: "error",
          message: "global.fecha.error.finAnteriorInicio",
        });
      } else {
        this.showError = false;
        this.mensajes = [];
      }
    } else {
      this.clearDatesValidators();
      this.showError = false;
      this.mensajes = [];
    }
  }

  private clearDatesValidators() {
    if (this.filtersForm.get("fechaFin").hasError("invalidDate")) {
      this.filtersForm
        // sin clearValidators() para no eliminar el required dinámico
        .get("fechaFin")
        .updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    if (this.filtersForm.get("fechaInicio").hasError("invalidDate")) {
      this.filtersForm
      // sin clearValidators() para no eliminar el required dinámico
        .get("fechaInicio")
        .updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
  }

  private checkDates(inicio, fin) {
    const inicioD = new Date(inicio);
    const finD = new Date(fin);
    return inicioD <= finD;
  }

  public checkValuesForm(): boolean {
    return (this.filtersForm.get("pais").value &&
      this.filtersForm.get("pais").enabled) ||
      (this.filtersForm.get("denominacion").value &&
        this.filtersForm.get("denominacion").enabled) ||
      this.filtersForm.get("campanya").value ||
      this.filtersForm.get("etiquetador").value ||
      this.filtersForm.get("paisDestino").value ||
      this.filtersForm.get("fechaInicio").value ||
      this.filtersForm.get("fechaFin").value ||
      this.filtersForm.get("desglosePaisDestino").value ||
      this.filtersForm.get("fechasImpresion").value ||
      this.filtersForm.get("agruparEtiquetador").value
      ? true
      : false;
  }

  public resetForm() {
    this.filtersForm.get("pais").disabled
      ? this.filtersForm
          .get("pais")
          .patchValue(this.filtersForm.get("pais").value)
      : this.filtersForm.controls["pais"].reset();
    this.filtersForm.get("paisDestino").reset();
    this.filtersForm.get("desglosePaisDestino").reset();
    this.filtersForm.get("fechasImpresion").reset();
    this.filtersForm.get("agruparEtiquetador").reset();
    this.filtersForm.get("etiquetador").reset();
    this.filtersForm.get("paisDestino").reset();
    this.filtersForm.get("fechaInicio").reset();
    this.filtersForm.get("fechaFin").reset();
    this.checkWarnings(this.filtersForm.get("pais").value);
  }

  public filtrar() {
    this.validDates();
    if (this.filtersForm.invalid) {
      if (
        Object.keys(this.filtersForm.controls).some((key) =>
          this.filtersForm.get(key).hasError("required")
        )
      ) {
        this.showError = true;
        this.mensajes = [];
        this.mensajes.push({
          class: "error",
          message: "global.error.requiredTotals",
        });
      }
    } else {
      this.applyFilters();
    }
  }

  public applyFilters() {
    this.currentPage = 1;
    this.firstItemList = this.itemsPerPage * (1 - 1);
    this.lastItemList = this.itemsPerPage * 1;
    this._etiquetadoContext.totalesFilters = {
      lsPaisIds: this.filtersForm.get("pais").value
        ? this.filtersForm.get("pais").value.length === this.paises.length
          ? null
          : this.filtersForm.get("pais").value
        : "",
      lsDenominacionIds: this.filtersForm.get("denominacion").value
        ? this.filtersForm.get("denominacion").value.length ===
          this.denominaciones.length
          ? null
          : this.filtersForm.get("denominacion").value
        : "",
      lsAnyos: this.filtersForm.get("campanya").value
        ? this.filtersForm.get("campanya").value
        : "",
      lsPaisDestinoIds: this.filtersForm.get("paisDestino").value
        ? this.filtersForm.get("paisDestino").value.length ===
          this.destinos.length
          ? null
          : this.filtersForm.get("paisDestino").value
        : "",
      lsMarcaIds: this.filtersForm.get("marca").value
        ? this.filtersForm.get("marca").value.length === this.marcas.length
          ? null
          : this.filtersForm.get("marca").value
        : "",
      lsEtiquetadorIds: this.filtersForm.get("etiquetador").value
        ? this.filtersForm.get("etiquetador").value.length ===
          this.etiquetadores.length
          ? null
          : this.filtersForm.get("etiquetador").value
        : "",
      agrupaDenominaciones: this.filtersForm.get("agruparEtiquetador").value
        ? this.filtersForm.get("agruparEtiquetador").value
        : false,
      mostrarDesglosePaisDestino: this.filtersForm.get("desglosePaisDestino")
        .value
        ? this.filtersForm.get("desglosePaisDestino").value
        : false,
      mostrarFechasImpresion: this.filtersForm.get("fechasImpresion").value
        ? this.filtersForm.get("fechasImpresion").value
        : false,
      tipoArchivo: "Pdf",
      fechaInicio: this.filtersForm.get("fechaInicio").value
        ? this._utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaInicio").value
          )
        : "",
      fechaFin: this.filtersForm.get("fechaFin").value
        ? this._utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaFin").value
          )
        : "",
      orderItems: null,
    };

    if (
      this.filtersForm.get("paisDestino").value ||
      this.filtersForm.get("desglosePaisDestino").value
    ) {
      this.destino = true;
      this.indexOrder = 6;
    } else {
      this.destino = false;
      this.indexOrder = 5;
    }

    if (this.filtersForm.get("fechasImpresion").value) {
      this.fechasImpresion = true;
      if (this.indexOrder === 6) {
        this.indexOrderFecha = 6;
        this.indexOrder = 8;
      } else {
        this.indexOrderFecha = 5;
        this.indexOrder = 7;
      }
    } else {
      this.fechasImpresion = false;
      this.indexOrder = 5;
    }

    this.getTotales();
  }

  public getTotales() {
    if (this._etiquetadoContext.totalesFilters) {
      this._filters = this._etiquetadoContext.totalesFilters;
    } else {
      this.applyFilters();
    }
    this._spinnerService.showSpinner();
    this._etiquetadoService
      .getTotales(this._filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(
        (resp) => {
          this.totalItems = resp.lsTotales.length;
          this.totales = resp;
        },
        (error) => {
          if (error.status === 420) {
            switch (error.error.ApiErrorCode) {
              case 3040:
                this.showError = true;
                this.mensajes.push({
                  class: "error",
                  message: "global.fecha.error.masDeUnAnyo",
                });
                break;
              case 6030:
                this.showError = true;
                this.mensajes.push({
                  class: "error",
                  message: "global.error.campanyaNoAccesible",
                });
                break;
              default:
                this.showError = true;
                this.mensajes.push({
                  class: "error",
                  message: "global.error.noResponse",
                });
                break;
            }
          } else {
            this.showError = true;
            this.mensajes.push({
              class: "error",
              message: "global.error.noResponse",
            });
          }
        }
      );
  }

  private checkCloseSpinner() {
    this.toCloseSpinner -= 1;
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public getIcon(prop: string) {
    let iconClass = "fa fa-sort";
    if (
      this._filters &&
      this._filters.orderItems &&
      this._filters.orderItems[0].orderProperty.indexOf(prop) != -1
    ) {
      iconClass =
        this._filters.orderItems[0].orderByDescending === true
          ? "fa fa-sort-down"
          : "fa fa-sort-up";
    }
    return iconClass;
  }

  public toOrderBy(columnFilter, idColumn) {
    if (this.totales && this.totales.lsTotales.length > 0) {
      if (this._etiquetadoContext.totalesFilters) {
        this._filters = this._etiquetadoContext.totalesFilters;
      }
    }

    if (!this.orderBy || this.orderBy.includes("DESC")) {
      this.orderBy = "ASC" + idColumn;
      this._filters.orderItems = [
        {
          orderProperty: columnFilter,
          orderByDescending: false,
        },
      ];
    } else if (this.orderBy.includes("ASC")) {
      this.orderBy = "DESC" + idColumn;
      this._filters.orderItems = [
        {
          orderProperty: columnFilter,
          orderByDescending: true,
        },
      ];
    }

    this._spinnerService.showSpinner();
    this._etiquetadoService
      .getTotales(this._filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(
        (resp) => {
          this.totales = resp;
        },
        (error) => {
          if (error.status === 420) {
            switch (error.error.ApiErrorCode) {
              case 3040:
                this.showError = true;
                this.mensajes.push({
                  class: "error",
                  message: "global.error.usuarioNoActivo",
                });
                break;
              default:
                this.showError = true;
                this.mensajes.push({
                  class: "error",
                  message: "global.error.noResponse",
                });
                break;
            }
          } else {
            this.showError = true;
            this.mensajes.push({
              class: "error",
              message: "session.error.verificationCodeError",
            });
          }
        }
      );
  }

  private downloadPdf() {
    this._etiquetadoService
        .getRepTotalesPdf(this._filters)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
          downloadLink.download = resp.nombreArchivo;
          downloadLink.click();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
  }

  private downloadCsv() {
    this._etiquetadoService
        .getRepTotalesCsv(this._filters)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
          downloadLink.download = resp.nombreArchivo;
          downloadLink.click();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
  }

  public exportPdfOrCsv(tipo) {
    if (this.totales && this.totales.lsTotales.length > 0) {
      var mimeType;
      if (this._etiquetadoContext.totalesFilters) {
        this._filters = this._etiquetadoContext.totalesFilters;
        this._filters.tamPagina = 0;
        if (tipo === "csv") {
          this._filters.tipoArchivo = "Csv";
          mimeType = "data:text/csv;base64,";
        } else if (tipo === "pdf") {
          this._filters.tipoArchivo = "Pdf";
          mimeType = "data:application/pdf;base64,";
        }
      }
      this._spinnerService.showSpinner();
      tipo === 'pdf' ? this.downloadPdf() : this.downloadCsv();
    } else {
      this.showError = true;
      this.mensajes.push({
        class: "error",
        message: "global.error.exportNoData",
      });
    }
  }

  public openDocHelp() {
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService
      .getDocHelp("Labeling_Totals.pdf")
      .toPromise()
      .finally(() => {
        this.checkCloseSpinner();
      })
      .then((resp) => {
        localStorage.setItem("base64", resp.base64Archivo);
        const url = this._router.serializeUrl(
          this._router.createUrlTree(["viewPdf"])
        );
        window.open(url, "_blank");
      });
  }

  shareCheckedListPaises(item: any[]) {
    this.filtersForm.get("pais").patchValue(item);
  }

  shareCheckedListDenominaciones(item: any[]) {
    this.filtersForm.get("denominacion").patchValue(item);
  }

  shareCheckedListCampanyas(item: any[]) {
    this.filtersForm.get("campanya").patchValue(item);
  }

  shareCheckedListMarcas(item: any[]) {
    this.filtersForm.get("marca").patchValue(item);
  }

  shareCheckedListEtiquetadores(item: any[]) {
    this.filtersForm.get("etiquetador").patchValue(item);
  }

  shareCheckedListDestinos(item: any[]) {
    this.filtersForm.get("paisDestino").patchValue(item);
  }
}
